export const getStyled = (theme) => ({
  chip: {
    margin: theme.spacing(0.5),
    cursor: 'pointer',
  },
});
